<template>
	<div class="bg-white px-3" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="d-flex a-center py-2">
			<div class="d-flex a-center" style="width: 300px;margin-right: 10px;">
				<div style="font-size: 10px;width: 50px;">客户：</div>
				<el-select v-model="search.kh_id" filterable style="width: 50%;" size="mini">
				    <el-option v-for="item in khlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
				<el-select v-model="search.kh_id" filterable style="width: 50%;margin-left: 10px;" size="mini">
				    <el-option v-for="item in khlist" :key="item.id" :label="item.j_name" :value="item.id"></el-option>
				</el-select>
			</div>
			<div style="margin-left: auto;" class="d-flex a-center">
				<el-button type="info" size="mini" @click="searchEvent">搜索</el-button>
				<el-button size="mini" @click="clearSearch">清空筛选条件</el-button>
			</div>
		</div>
		
		
		<div style="height: 40vh;overflow-y: auto;">
			<div style="width: 800px;display: flex;border-bottom: 1px solid #000000;">
				<div style="width: 200px;display: flex;justify-content: center; align-items: center;margin-bottom: 4px;">日期</div>
				<div style="width: 120px;display: flex;justify-content: center; align-items: center;">类型</div>
				<div style="width: 120px;display: flex;justify-content: center; align-items: center;">单号</div>
				<div style="width: 120px;display: flex;justify-content: center; align-items: center;">客户简称</div>
				<div style="width: 120px;display: flex;justify-content: center; align-items: center;">客户名称</div>
				<div style="width: 120px;display: flex;justify-content: center; align-items: center;">总金额</div>
			</div>
			<div style="width: 800px;display: flex;border-bottom: 1px solid #000000;" v-for="item in sjlistlcf">
				<div style="width: 200px;display: flex;justify-content: center; align-items: center;margin-top: 4px;margin-bottom: 4px;">{{item.create_time}}</div>
				<div style="width: 120px;display: flex;justify-content: center; align-items: center;">冷藏费</div>
				<div style="width: 120px;display: flex;justify-content: center; align-items: center;">{{item.bh}}</div>
				<div style="width: 120px;display: flex;justify-content: center; align-items: center;">{{item.khdata.name}}</div>
				<div style="width: 120px;display: flex;justify-content: center; align-items: center;">{{item.khdata.j_name}}</div>
				<div style="width: 120px;display: flex;justify-content: center; align-items: center;">{{item.zfy}}</div>
			</div>
			<!-- <div style="width: 100%;display: flex;margin-top: 10px;margin-bottom: 10px;">
				<div style="width: 33%;">合计面积：{{form.hjmj}}</div>
				<div style="width: 33%;">合计数量：{{form.hjjs}}</div>
				<div style="width: 33%;">合计重量：{{form.hjzl}}</div>
			</div> -->
		</div>
		<div style="height: 40vh;overflow-y: auto;">
			<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;">
				<div style="width: 8%;display: flex;justify-content: center; align-items: center;margin-bottom: 4px;">选择状态</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">待付单号</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">日期</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">客户简称</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">客户名称</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">发货方式</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">总金额</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">支付日期</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">支付人</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">确认还款</div>
			</div>
			<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;" v-for="item in sjlist">
				<div style="width: 8%;display: flex;justify-content: center; align-items: center;margin-top: 4px;margin-bottom: 4px;">支付</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">{{item.bh}}</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">{{item.create_time}}</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">{{item.khdata.j_name}}</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">{{item.khdata.name}}</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">{{item.hyfsdata.name}}</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">{{item.zje}}</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">{{item.zf_time}}</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">{{item.zfr}}</div>
				<div style="width: 10%;display: flex;justify-content: center; align-items: center;">{{item.qrhkr}}</div>
			</div>
		</div>
		
		<!-- 打印模板 -->
		<!-- <div class="print-div none" id="print_area" media="print">
			<div style="width: 100%;display: flex;margin-top: 4px;margin-bottom: 4px;">
				<div style="width: 40%;"></div>
				<div style="width: 40%;font-size: 24px;">代付运费单</div>
				<div style="width: 20%;">{{dydd.hyfsdata.name}}</div>
			</div>
			<div style="width: 100%;display: flex;margin-top: 4px;margin-bottom: 4px;">
				<div style="width: 30%;">客户名称：{{dydd.khdata.name}}</div>
				<div style="width: 20%;">简称：{{dydd.khdata.j_name}}</div>
				<div style="width: 25%;">代付日期：{{dydd.qrhk_time}}</div>
				<div style="width: 25%;">单号：{{dydd.bh}}</div>
			</div>
			<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;">
				<div style="width: 12%;display: flex;justify-content: center; align-items: center;margin-bottom: 4px;">供货方</div>
				<div style="width: 18%;display: flex;justify-content: center; align-items: center;">货物名称</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">件数</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">运费金额(元)</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">备注</div>
			</div>
			<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;" v-for="item in dydd.djglhw">
				<div style="width: 12%;display: flex;justify-content: center; align-items: center;margin-top: 4px;margin-bottom: 4px;">{{item.ghs}}</div>
				<div style="width: 18%;display: flex;justify-content: center; align-items: center;">{{item.hwmc}}</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">{{item.num}}</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">{{item.yf}}</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">{{item.desc}}</div>
			</div>
			<div style="width: 100%;display: flex;margin-top: 4px;margin-bottom: 4px;">
				<div style="width: 33%;">合计件数：{{dydd.hjjs}}</div>
				<div style="width: 33%;">大写：{{dydd.jedx}}</div>
				<div style="width: 33%;">合计金额：<span style="margin-right: 4px;">{{dydd.zje}}</span>元</div>
			</div>
			<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;">
				<div style="width: 34%;display: flex;font-size: 13px;margin-bottom: 4px;">广州诚晖冷冻食品物流有限公司</div>
				<div style="width: 66%;display: flex;font-size: 13px;">电话：0757-85709188，85709200，85709201，17708636608</div>
			</div>
			<div style="width: 100%;display: flex;margin-top: 4px;">
				<div style="width: 33%;">制单：{{dydd.cjrdata.name}}</div>
				<div style="width: 33%;">收款人：</div>
				<div style="width: 33%;">车牌号：</div>
			</div>
		</div> -->
	</div>
</template>

<script>
	import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	components: {
		buttonSearch
	},
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	data() {
		return {
			search:{
				kh_id: ''
			},
			khlist:[],
			
			
			
			
			
			
			form: {
				hjmj:0,
				hjzl:0,
				hjjs:0
			},
			times:'',
			cklist:[],
			ck_id:'',
			ckk:[],
			ck_k:'',
			type:'',
			czdata:[
				{
					id:0,
					name:'入仓'
				},
				{
					id:1,
					name:'加货'
				},
				{
					id:2,
					name:'出仓'
				}
			],
			sjlist:[],
			sjlistlcf:[],
			mrck:'',
			today:''
		};
	},
	computed: {
		...mapState({
			user: state => state.user.user
		})
	},
	mounted() {
		this.axios.get('/admin/khxxs', { token: true }).then(res => {
			this.khlist = res.data.data;
		});
		const moment = require('moment');
		const currentTime = moment().format('YYYY-MM-DD HH:mm:ss');
		this.today = currentTime
	},
	methods: {
		currk(val){
			let data = this.cklist.filter(item=>{
				return item.id == val
			})
			this.mrck = data[0].name
			
			
			
			this.axios.get('/admin/ckdjk?type='+this.ck_id, { token: true }).then(res => {
				this.ckk = res.data.data;
			});
		},
		// 清空筛选条件
		clearSearch() {
			this.search = {
				bh:'',
				kh_id: '',
				kstime: '',
				jstime: '',
				ck:'',
				ck_k:'',
				ck_q:'',
				ck_h:'',
				ck_l:'',
				zb:''
			};
		},
		// 搜索事件
		searchEvent() {
			this.axios.post('/admin/bb/qfbb', this.search, {
				token: true
			}).then(res => {
				this.sjlist = res.data.data
			})
			
			this.axios.post('/admin/bb/qfbblcf', this.search, {
				token: true
			}).then(res => {
				this.sjlistlcf = res.data.data
			})
		},
		
	}
};
</script>

<style>
	.container {
	  width: 400px;
	  height: 300px;
	  margin: 30px auto;
	  box-shadow: 0 0 2px gray;
	  padding: 20px;
	  overflow: scroll; 
	}
	
	.scroll {
	  width: 1400px;
	  height: 1300px;
	}
	
	.container::-webkit-scrollbar {
	  width: 10px;
	  height: 10px;
	}
	
	.container::-webkit-scrollbar-thumb {
	  background: linear-gradient(to bottom right, #4d7fff 0%, #1a56ff 100%);
	  border-radius: 5px;
	}
	
	.container::-webkit-scrollbar-track {
	  background-color: #ddd;
	  border: 1px solid #ccc;
	}
	
	.container::-webkit-scrollbar-button {
	  background-color: #4d7fff;
	  border-radius: 5px;
	}
	
	.container::-webkit-scrollbar-button:hover {
	  background-color: #999999;
	}
</style>
